/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { readAllNotification, getNotifications } from '../../api/notifications';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import NotificationComponent from './NotificationComponent';
import { FlexBox } from '../../common/Reusables';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NoData from 'Account/Resuseable/NoData';

const Notification = ({ closeModal }) => {
  const [data, setData] = useState([]);
  const [ref, inView] = useInView({
    threshold: 0
  });
  const queryClient = useQueryClient();
  const [page, setPage] = useState(1);
  const notificationMutation = useQuery(
    ['notification', { page: page }],
    getNotifications,
    {
      onSuccess: (res) => {
        setData((prev) => [...prev, ...res.results]);
      },
      cacheTime: 1
    }
  );
  useEffect(() => {
    if (inView && notificationMutation.data?.next) {
      setPage(page + 1);
    }
  }, [inView]);

  const readAllMutation = useMutation(readAllNotification, {
    onSuccess: () => {
      closeModal();
      queryClient.invalidateQueries('unread_count');
      setData([]);
      setPage(1);
      queryClient.invalidateQueries('notification');
    }
  });

  const clearAll = () => {
    readAllMutation.mutateAsync().then((res) => res);
  };

  return (
    <Notification.Wrapper>
      <FlexBox className='heading-container'>
        <div className='heading'>Notifications </div>
        <ChevronLeftIcon htmlColor='#2898a4' onClick={() => closeModal()} />
      </FlexBox>
      {/* <EmptyState ptext='You have no notification' /> */}
      {notificationMutation.isLoading && page === 1 ? (
        <CircularProgress color='secondary' />
      ) : (
        <>
          {readAllMutation.isLoading ? (
            <ClearAllText>Loading...</ClearAllText>
          ) : (
            data.length !== 0 && (
              <ClearAllText onClick={clearAll}>
                Clear all notification
              </ClearAllText>
            )
          )}
          {data.map((item, i) => (
            <NotificationComponent
              name={item.type}
              key={i}
              bgColor='#FAFAFA'
              icon={true}
              item={item}
              closeModal={closeModal}
            />
          ))}

          <Box ref={ref}></Box>
          {inView && notificationMutation.status === 'loading' && page > 1 && (
            <div>Loading..</div>
          )}
          {data.length === 0 && notificationMutation.isSuccess && (
            <NoData label='You have no notification' />
          )}
        </>
      )}
    </Notification.Wrapper>
  );
};

export default Notification;

Notification.Wrapper = styled.div`
  margin: -20px;
  .heading-container {
    background: #eaf8fa;
    padding: 40px 13px 18px 14px;
    margin-bottom: 24px;
    .heading {
      font-weight: 600;
      font-size: 24px;
      line-height: 128.86%;
      color: #2898a4;
    }
    svg {
      width: 31.79px;
      height: 30px;
      cursor: pointer;
    }
  }
`;

const ClearAllText = styled(Typography)`
  font-style: normal;
  font-weight: normal;
  font-size: 14.22px;
  line-height: 15px;
  color: #a8a8a8;
  margin: 35px 33px 22px;
  cursor: pointer;
`;
